<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-header-menu-action">
    <el-dropdown class="wy-header-manu-dropdown" ref="actionWidget" placement="top" trigger="click" 
      @command="handleChange" :hide-on-click="true" @visible-change="handleChangeVisible">
      <span class="el-dropdown-title wy-disable-select">
        <div class="el-dropdown-subtitle">
            {{ $t('menu.action.title') }}
        </div>
        <i class="el-icon-caret-right"></i>
      </span>
      <el-dropdown-menu class="wy-header-menu-panel wy-header-menu-action-panel" slot="dropdown">
        <transition name="bounce">
            <div class="menu-panel" v-if="isShow">
              <el-dropdown-item v-for="(item, index) in dataModel.actions" :command="index" :disabled="numOfTableRowsSelected < item.minSelected" :key="index">
                {{item.label}}
              </el-dropdown-item>
            </div>
        </transition>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'wy-header-menu-action',

  data() {
    return {
      isShow: false
    }
  },

  computed: {   
    ...mapGetters(['dataModel', 'numOfTableRowsSelected'])
  },

  methods: {
    handleChangeVisible(isOpen) {
      if(isOpen) {
        this.$refs.actionWidget.show();
        this.$refs.actionWidget.popperElm.style.transitionDelay = "0s";
        this.isShow = true;
      }
      else {
        this.$refs.actionWidget.hide();
        this.$refs.actionWidget.popperElm.style.transitionDelay = "1s";
        this.isShow = false;
      }
    },
    handleChange(index) {
      let selectedAction = this.dataModel.actions[index];
      this.$root.fireEvent({name: selectedAction.method});
    }
  }
}
</script>

<style lang="scss">
.wy-header-menu-action-panel {
  width: 200px;
}
</style>